import { useState, useEffect, useCallback } from 'react';
import baseURL from '../Components/url';

export const useColors = () => {
    const [colores, setColores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Cargar colores desde la API
    const cargarColores = useCallback(async (soloActivos = true) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${baseURL}/coloresGet.php`);
            const data = await response.json();

            if (data.success) {
                const coloresFiltrados = soloActivos
                    ? data.colores.filter(color => color.activo === 1 || color.activo === '1')
                    : data.colores;

                setColores(coloresFiltrados);
                return coloresFiltrados;
            } else {
                throw new Error(data.error || 'Error al cargar colores');
            }
        } catch (err) {
            setError(err.message);
            console.error('Error cargando colores:', err);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    // Agregar un nuevo color
    const agregarColor = useCallback(async (nombre, valor) => {
        try {
            const response = await fetch(`${baseURL}/coloresPost.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre, valor })
            });

            const data = await response.json();

            if (data.success) {
                await cargarColores(); // Recargar la lista
                return { success: true, mensaje: data.mensaje };
            } else {
                return { success: false, error: data.error };
            }
        } catch (err) {
            return { success: false, error: 'Error de conexión' };
        }
    }, [cargarColores]);

    // Actualizar un color
    const actualizarColor = useCallback(async (idColor, updates) => {
        try {
            const response = await fetch(`${baseURL}/coloresPut.php`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ idColor, ...updates })
            });

            const data = await response.json();

            if (data.success) {
                await cargarColores(); // Recargar la lista
                return { success: true, mensaje: data.mensaje };
            } else {
                return { success: false, error: data.error };
            }
        } catch (err) {
            return { success: false, error: 'Error de conexión' };
        }
    }, [cargarColores]);

    // Eliminar un color
    const eliminarColor = useCallback(async (idColor) => {
        try {
            const response = await fetch(`${baseURL}/coloresDelete.php?idColor=${idColor}`, {
                method: 'DELETE'
            });

            const data = await response.json();

            if (data.success) {
                await cargarColores(); // Recargar la lista
                return { success: true, mensaje: data.mensaje };
            } else {
                return { success: false, error: data.error };
            }
        } catch (err) {
            return { success: false, error: 'Error de conexión' };
        }
    }, [cargarColores]);

    // Obtener un color por nombre
    const obtenerColorPorNombre = useCallback((nombre) => {
        return colores.find(color =>
            color.nombre.toLowerCase() === nombre.toLowerCase()
        );
    }, [colores]);

    // Obtener colores activos solamente
    const coloresActivos = colores.filter(color => color.activo === 1 || color.activo === '1');

    // Cargar colores al montar el hook
    useEffect(() => {
        cargarColores();
    }, [cargarColores]);

    return {
        colores,
        coloresActivos,
        loading,
        error,
        cargarColores,
        agregarColor,
        actualizarColor,
        eliminarColor,
        obtenerColorPorNombre
    };
};